import React from 'react';
// eslint-disable-next-line import/no-named-as-default -- posthog-js re-exports its own default as a named `posthog` too
import posthog from 'posthog-js';
import { useDispatch } from 'react-redux';
import {
  DeprecatedModal,
  ModalCancelButton,
  ModalConfirmationButton,
  ModalText,
  ModalTitle,
} from '../../common/DeprecatedModal';
import { deleteEnvelope } from '../../store/envelopeManagement/actions';

interface IProps {
  envelopeId: string;
  close: () => void;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const DeleteEnvelopeModal = (props: IProps) => {
  const dispatch = useDispatch();
  const { envelopeId, close } = props;

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const onClickDelete = () => {
    posthog.capture('envelope_draft_deleted');
    dispatch(deleteEnvelope(envelopeId));
    close();
  };

  const title = <ModalTitle>Are you sure you want to delete your draft?</ModalTitle>;
  const content = (
    <>
      <ModalText>Deleting a draft cannot be undone.</ModalText>
      <ModalText>All signers and documents will be permanently deleted.</ModalText>
    </>
  );
  const actionButtons = (
    <>
      <ModalCancelButton onClick={close} aria-label="keep envelope">
        Keep Envelope
      </ModalCancelButton>
      <ModalConfirmationButton onClick={onClickDelete} aria-label="confirm delete envelope">
        Delete Draft
      </ModalConfirmationButton>
    </>
  );
  return <DeprecatedModal toggleModal={close} title={title} content={content} actionButtons={actionButtons} />;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default DeleteEnvelopeModal;
